/**
 * Core platform admin session helpers (not tied to an active organization).
 */

export function isCorePlatformUser(userData) {
  if (!userData) return false;
  if (userData.is_core_platform === true) return true;
  return !userData?.organization?.organization_id;
}

export function buildCoreSessionUser(user) {
  if (!user) return null;

  return {
    ...user,
    organization: null,
    user_active_organization: null,
    organizationuser: null,
    metadata: [],
    loginuser: null,
    is_core_platform: true,
  };
}

/** Scope key for datagrid / saved views when no tenant organization is active. */
export function getCoreScopeKey(userData) {
  const appUserId = userData?.application_user_id;
  if (appUserId) {
    return `core_${appUserId}`;
  }
  return "core";
}

export function getCoreDatagridKey(tableName, userData) {
  return `${tableName}_grid_${getCoreScopeKey(userData)}`;
}

export function resolveDatagridScope(userData) {
  const orgId = userData?.organization?.organization_id;
  if (orgId) {
    return {
      orgId: Number(orgId),
      datagridKeySuffix: String(orgId),
      organizationUserId:
        userData?.organizationuser?.organization_user_id ??
        userData?.metadata?.[0]?.organization_user_id ??
        null,
    };
  }

  return {
    orgId: null,
    datagridKeySuffix: getCoreScopeKey(userData),
    organizationUserId: null,
  };
}
